import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import MasterPage from "../master-page";
import localizationService from "../../services/localization-service";
import { getRequest, sendRequest } from "../../actions/portal.action";
import notification from "../../services/notification-service";
import storageService from "../../services/storage-service";
import config from "../../config";
import ModalDeselectGroupInfo from "../../components/modals/modal-deselect-group-info";
import { checkGroupAvailabilityMultiple } from "../../actions/portal.action";
import ClientRequestType from "../../models/ClientRequestType";
import MoonLoader from "react-spinners/MoonLoader";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../assets/css/stepper.css";
import Stepper from "../../components/Stepper";

//delete this comment

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Navigation } from "swiper/modules";

// Add Tailwind table components
const Table = ({ children, className = "", ...props }) => (
  <div className="overflow-x-auto rounded-lg">
    <table
      className={`min-w-full divide-y divide-gray-200 ${className}`}
      {...props}
    >
      {children}
    </table>
  </div>
);

const TableHead = ({ children, className = "", ...props }) => (
  <thead className={`bg-gray-50 ${className}`} {...props}>
    {children}
  </thead>
);

const TableBody = ({ children, className = "", ...props }) => (
  <tbody
    className={`bg-white divide-y divide-gray-200 ${className}`}
    {...props}
  >
    {children}
  </tbody>
);

const TableRow = ({ children, className = "", ...props }) => (
  <tr className={`hover:bg-gray-50 transition-colors ${className}`} {...props}>
    {children}
  </tr>
);

const TableCell = ({ children, className = "", ...props }) => (
  <td
    className={`px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700 ${className}`}
    {...props}
  >
    {children}
  </td>
);

const TableHeaderCell = ({ children, className = "", ...props }) => (
  <th
    className={`px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider ${className}`}
    {...props}
  >
    {children}
  </th>
);

// Add styled button component
const Button = ({
  children,
  onClick,
  disabled,
  className = "",
  variant = "primary",
  ...props
}) => {
  const baseClasses =
    "inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors min-w-[130px]";

  const variantClasses = {
    primary: "bg-[#9aa82d] hover:bg-[#7d8a1f] text-white focus:ring-[#9aa82d]",
    secondary: "bg-gray-600 text-white hover:bg-gray-700 focus:ring-gray-500",
    success: "bg-green-600 text-white hover:bg-green-700 focus:ring-green-500",
    danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
    warning:
      "bg-yellow-500 text-white hover:bg-yellow-600 focus:ring-yellow-500",
    outline:
      "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-[#9aa82d]",
  };

  const disabledClasses = "opacity-50 cursor-not-allowed";

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${
        disabled ? disabledClasses : ""
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

// Add a card component for consistent styling
const Card = ({ children, className = "", ...props }) => (
  <div className={`bg-white rounded-2xl shadow-xl p-8 ${className}`} {...props}>
    {children}
  </div>
);

// Add badge component for status indicators with improved typography
const Badge = ({ variant = "default", children }) => {
  const variantClasses = {
    default: "bg-gray-100 text-gray-800",
    primary: "bg-blue-100 text-blue-800",
    success: "bg-green-100 text-green-800",
    warning: "bg-yellow-100 text-yellow-800",
    danger: "bg-red-100 text-red-800",
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantClasses[variant]}`}
    >
      {children}
    </span>
  );
};

export const ProgramsPage = () => {
  const dispatch = useDispatch();
  // #Region state variables
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);

  const [validGroupOptions, setValidGroupOptions] = useState(true);

  const [selectedGroupModal, setSelectedGroupModal] = useState(false);
  const [selectedGroupDay, setSelectedGroupDay] = useState(null);

  const [deselectModalGroupDay, setDeselectModalGroupDay] = useState(null);
  const [deselectModalGroupName, setDeselectModalGroupName] = useState(null);

  const [step, setStep] = useState(1);
  const [disableGoNext, setDisableGoNext] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [submittedGroups, setSubmittedGroups] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [warningMessage2, setWarningMessage2] = useState(true);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const [groupsWithSameName, setGroupsWithSameName] = useState([]);
  const [requestType, setRequestType] = useState(0);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [treatmentToShow, setTreatmentToShow] = useState({ TreatmentId: 0 });
  const [clientRequest, setClientRequest] = useState(null);
  const [groupToShow, setGroupToShow] = useState({ GroupId: 0 });
  const requestLoading = useSelector((state) => state.portal.requestLoading);
  const selectedlang = useSelector((state) => state.account.lang);
  const [currentTimeZone, setCurrentTimeZone] = useState(null);
  const [selectedDay, setSelectedDay] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [availableWeeks, setAvailableWeeks] = useState([]);
  const [selectedStartWeek, setSelectedStartWeek] = useState(null);
  const [expandedAccordions, setExpandedAccordions] = useState([0]);

  const daysForButtons = [
    { text: selectedlang == "en-CA" ? "Monday" : "Lundi", value: 1 },
    { text: selectedlang == "en-CA" ? "Tuesday" : "Mardi", value: 2 },
    { text: selectedlang == "en-CA" ? "Wednesday" : "Mercredi", value: 3 },
    { text: selectedlang == "en-CA" ? "Thursday" : "Jeudi", value: 4 },
    { text: selectedlang == "en-CA" ? "Friday" : "Vendredi", value: 5 },
    { text: selectedlang == "en-CA" ? "Saturday" : "Samedi", value: 6 },
  ];
  const isAtStart = currentIndex === 0;
  const isAtEnd = currentIndex === availableWeeks.length - 1;
  const [selectedGroup, setSelectedGroup] = useState("");
  const [openDeselectGroupModal, setOpenDeselectGroupModal] = useState(false);
  const [reInvoke, setReInvoke] = useState(true);
  const isFirstRender = useRef(true);
  // let originalGroup = [];

  // TEMPORARY SOLUTION: StartDate in SelectedAccountGroupIdList is saved as a string. If the string is represinting date in French we need to convert it to English
  // TO DO: Need to save date as DateTime and to write a script which will convert already saved string dates to DateTime
  const frToEnMonths = {
    "janv.": "Jan",
    "févr.": "Feb",
    mars: "Mar",
    "avr.": "Apr",
    mai: "May",
    juin: "Jun",
    "juil.": "Jul",
    août: "Aug",
    "sept.": "Sep",
    "oct.": "Oct",
    "nov.": "Nov",
    "déc.": "Dec",
  };

  // #Endregion state variables

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setReInvoke((prev) => !prev);
    setStep(1);
    setSelectedGroups([]);
  }, [selectedlang]);

  useEffect(() => {
    checkCanGoNext();
  }, [selectedGroups]);

  useEffect(() => {
    getUserRequest();

    if (window.innerWidth < 1300) {
      setIsDesktopResolution(false);

      // Add null checks and make the DOM manipulation more defensive
      const mainContainer = document.querySelector("main.main-app-container");
      const mainPy3 = document.querySelector("main.py-3");

      if (mainContainer) {
        mainContainer.classList.add("mobile");
      }

      if (mainPy3) {
        mainPy3.classList.add("mobile");
      }

      return () => {
        if (mainContainer) {
          mainContainer.classList.remove("mobile");
        }
        if (mainPy3) {
          mainPy3.classList.remove("mobile");
        }
      };
    }
  }, [reInvoke]);

  useEffect(() => {
    checkCanGoNext();
    setMobileView();
  }, [step]);

  useEffect(() => {
    const mainContainer = Array.from(
      document.querySelectorAll("main.main-app-container"),
    );
    mainContainer[0].classList.add("programs-page-container");

    return () => {
      mainContainer[0].classList.remove("programs-page-container");
    };
  }, []);

  useEffect(() => {
    var ctz = storageService.getStorageItem(config.TIMEZONE);
    if (ctz != null) {
      setCurrentTimeZone(ctz);
    }
  }, [currentTimeZone]);

  const updateAvailableWeeks = (availableGroups, selectedGroups) => {
    for (let i = 0; i < availableGroups.length; i++) {
      const obj1 = availableGroups[i];

      const matchingObj = selectedGroups[0].find(
        (obj2) => obj2.StartDate === obj1.StartDate,
      );

      if (matchingObj) {
        obj1.Selected = true;
      }
    }
    return availableGroups;
  };

  //When switching through the available weeks selection
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % availableWeeks.length);
    handleChange(
      availableWeeks[(currentIndex + 1) % availableWeeks.length]?.value,
    );
  };

  //When switching through the available weeks selection
  const handlePrevious = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + availableWeeks.length) % availableWeeks.length,
    );
    handleChange(
      availableWeeks[
        (currentIndex - 1 + availableWeeks.length) % availableWeeks.length
      ]?.value,
    );
  };

  //Get available groups when Week Start is changed
  const handleChange = async (selectedWeekStart) => {
    if (selectedGroups?.[0].length == 0 || !selectedGroups)
      setSelectedStartWeek(selectedWeekStart);
    let availableGroups = await checkGroupAvailability(
      selectedWeekStart,
      clientRequest?.[0]?.TreatmentId,
      clientRequest?.[0]?.EnrolledGroupId,
    );
    availableGroups = updateAvailableWeeks(availableGroups, selectedGroups);
    let updatedClientRequest = clientRequest;
    updatedClientRequest[0].SingleGroupResponse = availableGroups;
    if (selectedGroups?.[0].length > 1 || selectedGroups) {
      for (const obj of updatedClientRequest[0].SingleGroupResponse) {
        selectedGroups[0].forEach((sg) => {
          if (sg.GroupId === obj.GroupId && sg.StartDate === obj.StartDate)
            obj.Selected = true;
          else obj.Selected = false;
        });
      }
    }
    setClientRequest(updatedClientRequest);
    setGroupData(updatedClientRequest);
    setGroupToShow(updatedClientRequest[0].SingleGroupResponse[0]);
  };

  const checkGroupAvailability = async (
    startWeek,
    TreatmentId,
    EnrolledGroupId,
  ) => {
    return new Promise((resolve, reject) => {
      dispatch(
        checkGroupAvailabilityMultiple(
          startWeek,
          TreatmentId,
          EnrolledGroupId,
          selectedlang,
        ),
      )
        .then(async function (response) {
          resolve(response.Result.SingleGroupResponse);
        })
        .catch(function (res) {
          notification.error(
            localizationService.getLocalizationValue(
              "programSelectionError",
              selectedlang,
            ),
          );
          reject(res);
        });
    });
  };

  //Get Static List of Mondays for the next "numWeeks" weeks
  const getAvailableWeeks = (numWeeks, nextScheduledDateString) => {
    const cleanedDateString = nextScheduledDateString.split(" -")[0];
    const nextMonday = new Date(cleanedDateString);

    const dates = [];

    for (let i = 0; i < numWeeks; i++) {
      const date = new Date(
        nextMonday.getFullYear(),
        nextMonday.getMonth(),
        nextMonday.getDate() + i * 7,
      );

      let day = "";
      let month = "";
      if (selectedlang == "en-CA") {
        day = date.toLocaleString("en-us", { weekday: "long" });
        month = date.toLocaleString("en-us", { month: "long" });
      } else {
        day = date.toLocaleString("fr-FR", { weekday: "long" });
        month = date.toLocaleString("fr-FR", { month: "long" });
      }

      const dayOfMonth = date.getDate();
      const year = date.getFullYear();

      const formattedDate = `${day}, ${month} ${dayOfMonth}, ${year}`;
      dates.push({ label: formattedDate, value: formattedDate });
    }

    setAvailableWeeks(dates);
    return dates;
  };

  const getUserRequest = () => {
    dispatch(getRequest(selectedlang))
      .then(async function (response) {
        if (response.length !== 0) {
          //Handle Switch Requests
          if (response[0].Status !== 1) {
            if (response?.[0]?.Type === ClientRequestType.Switch) {
              setRequestType(ClientRequestType.Switch);
              setValidGroupOptions(false);
            } else {
              setValidGroupOptions(
                response.some((obj) => obj.SingleGroupResponse.length === 0),
              );
            }
            setSubmitted(true);
            setTreatmentToShow(response[0]);
            setSubmittedGroups(response);
            setGroupData(response);
          } else {
            if (response?.[0]?.Type === ClientRequestType.Switch) {
              setValidGroupOptions(false);
              let weeks = getAvailableWeeks(12, response?.[0].StartDateEng);
              setRequestType(1);
              setSelectedStartWeek(weeks?.[0]?.value);
              let availableGroups = await checkGroupAvailability(
                weeks?.[0]?.value,
                response?.[0]?.TreatmentId,
                response?.[0]?.EnrolledGroupId,
              );
              response[0].SingleGroupResponse = availableGroups;
            } else {
              setValidGroupOptions(
                response.some((obj) => obj.SingleGroupResponse.length === 0),
              );
            }

            setEndDate(response[0].EndDate);
            setStartDate(response[0].StartDate);
            setClientRequest(response);
            // for mobile reso
            setGroupToShow(response[0].SingleGroupResponse[0]);
            let groupsByDay = response[0].SingleGroupResponse.filter(
              (x) => x.StartDateDay == 1,
            );
            showGroupInfo(groupsByDay[0]);

            // for desktop reso
            setGroupData(response);
            setResponseData(response);
            setSelectedGroups(new Array(response.length).fill([]));
          }
        } else {
          setValidGroupOptions(false);
        }
      })
      .catch(function (res) {
        setValidGroupOptions(false);
      });
  };

  //#region Desktop reso methods

  const incrementStep = () => {
    setStep(step + 1);
    setSelectedDay(1);
    setGroupsWithSameName([]);
    setExpandedAccordions([0]);
    const currentTreatment = groupData.find(
      (treatment) => treatment.CountId === step + 1,
    );
    const defaultGroup = currentTreatment?.SingleGroupResponse.find(
      (group) => group.StartDateDay === 1,
    );

    if (defaultGroup) {
      setGroupToShow(defaultGroup);
      showGroupInfo(groupToShow);
    }
    setGroupToShow({ GroupId: 0 });
  };

  const decrementStep = () => {
    setStep(step - 1);
    setSelectedDay(1);
    setSelectedGroupDay(null);
    setDeselectModalGroupDay(null);
    setActiveSlideIndex(0);
    setExpandedAccordions([0]);

    if (groupToShow && groupToShow.GroupName) {
      const updatedGroupsWithSameName = groupData[
        step - 2
      ].SingleGroupResponse.filter(
        (group) =>
          group.StartDateDay === 1 && group.GroupName === groupToShow.GroupName,
      );

      setGroupsWithSameName(updatedGroupsWithSameName);
    }
    setGroupToShow({ GroupId: 0 });
  };
  const fillDeselectModalInfo = (group) => {
    if (!group) {
      return;
    }

    const groupDay = group.StartDateDay;
    const groupName = group.GroupName;

    setDeselectModalGroupDay(groupDay);
    setDeselectModalGroupName(groupName);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const convertFrDateToEnglish = (frenchStringDate) => {
    let englishStringDate = frenchStringDate;

    for (const [fr, en] of Object.entries(frToEnMonths)) {
      englishStringDate = englishStringDate.replace(fr, en);
    }

    return englishStringDate;
  };

  const Submit = () => {
    const groupsToSend = selectedGroups.map((groups) =>
      groups.map((g) => ({
        ...g,
        NumberOfSessions: g.NumberOfSessions ?? 0,
        StartDate:
          selectedlang == "fr-CA"
            ? convertFrDateToEnglish(g.StartDate)
            : g.StartDate,
      })),
    );

    dispatch(sendRequest(groupsToSend))
      .then(function (response) {
        notification.success(
          localizationService.getLocalizationValue(
            "programSelectionSuccess",
            selectedlang,
          ),
        );
        //Refreshing the page instead of getting user request (temp fix for html breaking)
        handleRefresh();
        //getUserRequest();
      })
      .catch(function (res) {
        notification.error(
          localizationService.getLocalizationValue(
            "programSelectionError",
            selectedlang,
          ),
        );
      });
  };
  const canSelectGroup = () => {
    let canSelect = true;
    // check if there are already 2 groups selected from Treatment
    if (selectedGroups[step - 1].length > 1) {
      canSelect = false;
    }
    //check if group that is already selected have enough space, if not, we allow selection of one more
    if (
      selectedGroups[step - 1].length === 1 &&
      selectedGroups[step - 1][0].Spaces > 2
    ) {
      canSelect = false;
    }

    return canSelect;
  };

  const checkCanGoNext = () => {
    let disable = true;

    if (
      selectedGroups &&
      selectedGroups.length > 0 &&
      selectedGroups.length > step - 1
    ) {
      if (
        selectedGroups[step - 1].length === 1 &&
        selectedGroups[step - 1][0].Spaces > 2
      ) {
        disable = false;
      }

      if (selectedGroups[step - 1].length === 2) {
        disable = false;
      }

      if (
        selectedGroups[step - 1].length === 1 &&
        selectedGroups[step - 1][0].Spaces < 3 &&
        groupData[step - 1].length === 1
      ) {
        disable = false;
      }

      if (
        selectedGroups[step - 1].length === 1 &&
        selectedGroups[step - 1][0].Spaces < 3 &&
        responseData[step - 1].SingleGroupResponse.length === 1
      ) {
        disable = false;
      }

      setDisableGoNext(disable);
    } else {
      setDisableGoNext(disable);
    }
  };

  const selectGroup = (data, groupId) => {
    if (!disableGoNext) {
      const currentTreatment = groupData.find(
        (treatment) => treatment.CountId === step,
      );

      if (currentTreatment) {
        const selectedGroupsForTreatment = selectedGroups[step - 1];

        const selectedGroupForTreatment = selectedGroupsForTreatment.find(
          (group) => group.TreatmentId === currentTreatment.TreatmentId,
        );

        if (selectedGroupForTreatment) {
          const groupDay = selectedGroupForTreatment.StartDateDay;
          const groupName = selectedGroupForTreatment.GroupName;

          setDeselectModalGroupDay(groupDay);
          setDeselectModalGroupName(groupName);
          setSelectedGroup(groupName);
          setSelectedGroupDay(groupDay);
        }
      }
      fillDeselectModalInfo();
      setOpenDeselectGroupModal(true);

      return;
    }

    if (responseData[step - 1].SingleGroupResponse.length === 1) {
      setWarningMessage2(false);
    }

    if (data.Spaces < 3 && selectedGroups[step - 1].length === 0) {
      setSelectedGroupModal(true);
    }

    let groupSelected = false;

    if (canSelectGroup()) {
      const temp = JSON.parse(JSON.stringify(groupData));
      temp[step - 1].SingleGroupResponse.find(
        (x) => x.GroupId == groupId,
      ).Selected = true;

      setGroupData(temp);

      const original = selectedGroups;

      const tempselectedGroups = [...original[step - 1], data];

      original[step - 1] = tempselectedGroups;
      setSelectedGroups(original);
      checkCanGoNext();
      groupSelected = true;
      //deselect modal info
    }

    return groupSelected;
  };

  const deselectGroup = (data, groupId) => {
    const temp = JSON.parse(JSON.stringify(groupData));
    temp[step - 1].SingleGroupResponse.find(
      (x) => x.GroupId == groupId,
    ).Selected = false;
    setGroupData(temp);

    const list = selectedGroups;
    const sublist = list[step - 1];

    list[step - 1] = sublist.filter((x) => x.GroupId !== data.GroupId);

    setSelectedGroups(list);
    checkCanGoNext();
  };

  const filterGroupsByDay = (day, isMobile) => {
    setSelectedDay(day);
    setExpandedAccordions([0]);

    if (isMobile) {
      let groupsByDay = groupData[step - 1].SingleGroupResponse.filter(
        (x) => x.StartDateDay == day,
      );
      showGroupInfo(groupsByDay[0]);
    }
  };

  useEffect(() => {
    if (groupToShow && groupToShow.GroupName) {
      const updatedGroupsWithSameName = groupData[
        step - 1
      ].SingleGroupResponse.filter(
        (group) =>
          group.StartDateDay === 1 && group.GroupName === groupToShow.GroupName,
      );

      setGroupsWithSameName(updatedGroupsWithSameName);
    }
  }, [groupToShow]);

  const displayDay = (day) => {
    let selectedDay = "";
    switch (day) {
      case 1:
        selectedDay = "Monday";
        break;
      case 2:
        selectedDay = "Tuesday";
        break;
      case 3:
        selectedDay = "Wednesday";
        break;
      case 4:
        selectedDay = "Thursday";
        break;
      case 5:
        selectedDay = "Friday";
        break;
      case 6:
        selectedDay = "Saturday";
        break;
      default:
        break;
    }

    return selectedDay;
  };

  //#endregion Desktop reso methods

  //#region Mobile reso methods

  const showGroupInfo = (group) => {
    setGroupToShow(group);
    // setIsGroupSelected(false);
  };

  const showSelectedTreatment = (index) => {
    if (submitted) {
      setTreatmentToShow(submittedGroups[index]);
    } else {
      setTreatmentToShow(selectedGroups[index]);
    }
  };

  const handleSlideChange = (swiper) => {
    setActiveSlideIndex(swiper.activeIndex);
  };

  const selectGroupMobile = (groupId) => {
    if (!disableGoNext && requestType != ClientRequestType.Switch) {
      const currentTreatment = groupData.find(
        (treatment) => treatment.CountId === step,
      );

      if (currentTreatment) {
        const selectedGroupsForTreatment = selectedGroups[step - 1];

        const selectedGroupForTreatment = selectedGroupsForTreatment.find(
          (group) => group.TreatmentId === currentTreatment.TreatmentId,
        );

        if (selectedGroupForTreatment) {
          const groupDay = selectedGroupForTreatment.StartDateDay;
          const groupName = selectedGroupForTreatment.GroupName;

          setDeselectModalGroupDay(groupDay);
          setDeselectModalGroupName(groupName);
        }
      }
      fillDeselectModalInfo();
      setOpenDeselectGroupModal(true);

      return;
    }

    if (groupData[step - 1]?.SingleGroupResponse) {
      const activeGroup = groupData[step - 1].SingleGroupResponse.find(
        (group) => group.GroupId === groupId,
      );

      if (activeGroup) {
        const groupSelected = selectGroup(activeGroup, groupId);

        if (groupSelected) {
          const updatedGroupData = [...groupData];
          const groupIndex = updatedGroupData[
            step - 1
          ].SingleGroupResponse.findIndex((group) => group.GroupId === groupId);

          const groupName = activeGroup.GroupName;
          const groupDay = activeGroup.StartDateDay;

          updatedGroupData[step - 1].SingleGroupResponse[groupIndex] = {
            ...activeGroup,
            Selected: true,
          };

          setGroupData(updatedGroupData);
          setGroupToShow({ ...activeGroup, Selected: true });

          setSelectedGroupDay(groupDay);
          setSelectedGroup(groupName);

          setDeselectModalGroupDay(groupDay);
          setDeselectModalGroupName(groupName);
        }
      }
    }
  };

  const deSelectGroupMobile = (groupId) => {
    if (groupData[step - 1]?.SingleGroupResponse) {
      const activeGroup = groupData[step - 1].SingleGroupResponse.find(
        (group) => group.GroupId === groupId,
      );

      if (activeGroup) {
        deselectGroup(activeGroup, groupId);

        const updatedGroupData = [...groupData];
        const groupIndex = updatedGroupData[
          step - 1
        ].SingleGroupResponse.findIndex((group) => group.GroupId === groupId);

        if (groupIndex !== -1) {
          updatedGroupData[step - 1].SingleGroupResponse[groupIndex] = {
            ...activeGroup,
            Selected: false,
          };

          setGroupData(updatedGroupData);
          setGroupToShow({ ...groupToShow, Selected: false });
        }
      }
    }
  };

  const setMobileView = () => {
    if (
      step > 0 &&
      groupData &&
      groupData.length > 0 &&
      step <= groupData.length
    ) {
      setGroupToShow(groupData[step - 1].SingleGroupResponse[0]);
    }

    if (step > 1 && step > groupData.length) {
      showSelectedTreatment(0);
    }
  };
  const closeDeselectModal = () => {
    setOpenDeselectGroupModal(false);
  };

  const showGroupInfoByGroupName = (groupName) => {
    setGroupsWithSameName([]);

    const groupsWithSameName = groupData[step - 1].SingleGroupResponse.filter(
      (group) =>
        group.StartDateDay === selectedDay && group.GroupName === groupName,
    );

    if (groupsWithSameName.length > 0) {
      setGroupsWithSameName(groupsWithSameName);
      const selectedGroup = groupsWithSameName[0];
      setGroupToShow(selectedGroup);
    }
  };

  const toggleAccordion = (index) => {
    setExpandedAccordions((prev) => {
      if (prev.includes(index)) {
        // Remove index if already expanded
        return prev.filter((i) => i !== index);
      } else {
        // Add index to expanded list
        return [...prev, index];
      }
    });
  };
  //#endregion Mobile reso methods
  return (
    <MasterPage>
      <React.Fragment>
        <div
          className="overlay"
          style={requestLoading === false ? { display: "none" } : {}}
        >
          <MoonLoader
            color="#9aa82d"
            size={80}
            loading={requestLoading}
            aria-label="Loading Spinner"
          />
        </div>
        <ModalDeselectGroupInfo
          selectedStartWeek={selectedStartWeek}
          requestType={requestType}
          group={selectedGroup}
          day={displayDay(selectedGroupDay)}
          openModal={openDeselectGroupModal}
          closeModal={closeDeselectModal}
        ></ModalDeselectGroupInfo>
        {currentTimeZone ? (
          requestLoading === false ? (
            <div>
              {selectedGroupModal && (
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
                  <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
                    <div
                      className="px-6 py-4 border-b border-gray-200"
                      style={{ position: "relative" }}
                    >
                      <h3 className="text-lg font-medium text-gray-900">
                        {localizationService.getLocalizationValue(
                          "selectGroupTitle",
                          selectedlang,
                        )}
                      </h3>
                      <i
                        className="fas fa-times"
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "6px",
                        }}
                        onClick={() => setSelectedGroupModal(false)}
                      ></i>
                    </div>
                    <div className="px-6 py-4">
                      <div className="flex items-center p-4 bg-red-50 border-l-4 border-red-400 rounded-lg">
                        <div className="flex-shrink-0">
                          <i className="fas fa-exclamation-triangle text-red-500 mr-3"></i>
                        </div>
                        <div>
                          <p className="text-sm text-red-700">
                            {warningMessage2 == true
                              ? localizationService.getLocalizationValue(
                                  "programWarningMessage1",
                                  selectedlang,
                                )
                              : localizationService.getLocalizationValue(
                                  "programWarningMessage3",
                                  selectedlang,
                                )}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
                      <button
                        onClick={() => setSelectedGroupModal(false)}
                        className={`inline-flex ${!isDesktopResolution ? "w-[100%]" : "w-[70%]"} justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary`}
                      >
                        {localizationService.getLocalizationValue(
                          "confirm",
                          selectedlang,
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div
                className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50"
                style={
                  validGroupOptions === true
                    ? {
                        display: "flex",
                      }
                    : { display: "none" }
                }
              >
                <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
                  <div
                    className="px-6 py-4 border-b border-gray-200"
                    style={{ position: "relative" }}
                  >
                    <h3 className="text-lg font-medium text-gray-900">
                      {localizationService.getLocalizationValue(
                        "noGroupsAvailable",
                        selectedlang,
                      )}
                    </h3>
                    <i
                      className="fas fa-times"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "6px",
                      }}
                      onClick={() => setValidGroupOptions(false)}
                    ></i>
                  </div>
                  <div className="px-6 py-4">
                    <div className="flex items-center p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-lg">
                      <div className="flex-shrink-0">
                        <i className="fas fa-exclamation-triangle text-yellow-500 mr-3"></i>
                      </div>
                      <div>
                        <p className="text-sm text-yellow-700">
                          {localizationService.getLocalizationValue(
                            "programWarningMessage4",
                            selectedlang,
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
                    <button
                      onClick={() => setValidGroupOptions(false)}
                      className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                      {localizationService.getLocalizationValue(
                        "close",
                        selectedlang,
                      )}
                    </button>
                  </div>
                </div>
              </div>
              {groupData.length === 0 && submittedGroups.length === 0 ? (
                <div className="p-4 rounded-lg bg-yellow-50 border border-yellow-200 text-yellow-800">
                  {localizationService.getLocalizationValue(
                    "noClientRequest",
                    selectedlang,
                  )}
                </div>
              ) : isDesktopResolution ? (
                <div style={{ width: "100%", maxWidth: "100%" }}>
                  {submitted === true ? (
                    <div className="submitted-requests-container">
                      <div>
                        <h4 className="text-xl font-semibold text-gray-800 mb-4 uppercase">
                          {localizationService.getLocalizationValue(
                            "submittedRequest",
                            selectedlang,
                          )}
                        </h4>
                      </div>
                      <div className="table-box">
                        <Table responsive="true" className="groupTable">
                          <thead>
                            <tr>
                              <th style={{ whiteSpace: "nowrap" }}>
                                {localizationService.getLocalizationValue(
                                  "treatmentsTitle",
                                  selectedlang,
                                )}
                              </th>
                              <th style={{ whiteSpace: "nowrap" }}>Group</th>
                              {requestType === ClientRequestType.Switch ? (
                                <th style={{ whiteSpace: "nowrap" }}>
                                  {localizationService.getLocalizationValue(
                                    "switchStartDateTime",
                                    selectedlang,
                                  )}
                                </th>
                              ) : (
                                <th style={{ whiteSpace: "nowrap" }}>
                                  {localizationService.getLocalizationValue(
                                    "startDateTime",
                                    selectedlang,
                                  )}
                                </th>
                              )}
                              <th style={{ whiteSpace: "nowrap" }}>
                                {localizationService.getLocalizationValue(
                                  "counsellor",
                                  selectedlang,
                                )}
                              </th>
                              <th
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                {localizationService.getLocalizationValue(
                                  "spaces",
                                  selectedlang,
                                )}
                              </th>
                              {requestType === ClientRequestType.Switch ? (
                                <></>
                              ) : (
                                <>
                                  <th
                                    style={{ whiteSpace: "nowrap" }}
                                    className="text-center"
                                  >
                                    {localizationService.getLocalizationValue(
                                      "sessionHeading",
                                      selectedlang,
                                    )}
                                  </th>
                                </>
                              )}
                              <th
                                style={{ whiteSpace: "nowrap" }}
                                className="text-center"
                              >
                                {localizationService.getLocalizationValue(
                                  "status",
                                  selectedlang,
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {submittedGroups.map((treatment, index) => (
                              <tr key={index}>
                                <td>
                                  {
                                    treatment.SingleGroupResponse[0]
                                      .TreatmentName
                                  }
                                </td>
                                <td style={{ whiteSpace: "nowrap" }}>
                                  {treatment.SingleGroupResponse.map(
                                    (group, index2) => (
                                      <div key={index2}>{group.GroupName}</div>
                                    ),
                                  )}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }}>
                                  {treatment.SingleGroupResponse.map(
                                    (group, index2) => (
                                      <div key={index2}>{group.StartDate}</div>
                                    ),
                                  )}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }}>
                                  {treatment.SingleGroupResponse.map(
                                    (group, index2) => (
                                      <div key={index2}>{group.Counsellor}</div>
                                    ),
                                  )}
                                </td>
                                <td
                                  className="text-center"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  {treatment.SingleGroupResponse.map(
                                    (group, index2) => (
                                      <div className="text-center" key={index2}>
                                        {group.Spaces}
                                      </div>
                                    ),
                                  )}
                                </td>
                                {requestType === ClientRequestType.Switch ? (
                                  <></>
                                ) : (
                                  <>
                                    <td
                                      className="text-center"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      {treatment.SingleGroupResponse.map(
                                        (group, index2) => (
                                          <div
                                            className="text-center"
                                            key={index2}
                                          >
                                            {group.NumberOfSessions}
                                          </div>
                                        ),
                                      )}
                                    </td>
                                  </>
                                )}
                                <td className="text-center">
                                  <div
                                    className="status-badge-box"
                                    style={{
                                      height:
                                        treatment.SingleGroupResponse.length ===
                                        1
                                          ? "auto"
                                          : "",
                                    }}
                                  >
                                    {treatment.SingleGroupResponse.map(
                                      (group, index2) =>
                                        group.Status === 2 ? (
                                          <Badge variant="warning" key={index2}>
                                            {localizationService.getLocalizationValue(
                                              "pending",
                                              selectedlang,
                                            )}
                                          </Badge>
                                        ) : group.Status === 3 ? (
                                          <Badge variant="success">
                                            {localizationService.getLocalizationValue(
                                              "approved",
                                              selectedlang,
                                            )}
                                          </Badge>
                                        ) : (
                                          <Badge variant="danger">
                                            {localizationService.getLocalizationValue(
                                              "rejected",
                                              selectedlang,
                                            )}
                                          </Badge>
                                        ),
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ width: "100%", maxWidth: "100%" }}>
                        <div style={{ width: "100%", maxWidth: "100%" }}>
                          <Stepper
                            steps={[
                              ...groupData.map((data) => ({
                                name: data.TreatmentName,
                              })),
                              {
                                name: localizationService.getLocalizationValue(
                                  "reviewAndSubmit",
                                  selectedlang,
                                ),
                              },
                            ]}
                            currentStep={step}
                            complete={step > groupData.length + 1}
                          />
                        </div>
                      </div>
                      {requestType === ClientRequestType.Switch ? (
                        <div className="flex justify-between mb-1">
                          {" "}
                          <h4 className="text-xl font-semibold text-gray-800 uppercase mt-3">
                            {step === 1
                              ? localizationService.getLocalizationValue(
                                  "programsTitleSwitch",
                                  selectedlang,
                                )
                              : step === groupData.length + 1
                                ? localizationService.getLocalizationValue(
                                    "reviewAndSubmit",
                                    selectedlang,
                                  )
                                : localizationService.getLocalizationValue(
                                    "programsTitleSwitch",
                                    selectedlang,
                                  )}
                          </h4>
                        </div>
                      ) : (
                        <div
                          className="flex justify-between mt-6"
                          style={{ marginBottom: "12px" }}
                        >
                          {" "}
                          <h4 className="text-xl font-semibold text-gray-800 uppercase mt-3">
                            {step === 1
                              ? localizationService.getLocalizationValue(
                                  "programsTitle",
                                  selectedlang,
                                )
                              : step === groupData.length + 1
                                ? localizationService.getLocalizationValue(
                                    "reviewAndSubmit",
                                    selectedlang,
                                  )
                                : localizationService.getLocalizationValue(
                                    "programsTitle",
                                    selectedlang,
                                  )}
                          </h4>
                        </div>
                      )}
                      <div className="step-one-intro-box bg-white rounded-2xl shadow-xl p-8">
                        {step === 1 ? (
                          <>
                            {requestType !== 1 ? (
                              <>
                                <p className="text-base text-gray-700 leading-relaxed mb-2">
                                  {localizationService.getLocalizationValue(
                                    "introParagraphPart1",
                                    selectedlang,
                                  )}
                                  <b>{endDate}</b>.{" "}
                                  {localizationService.getLocalizationValue(
                                    "introParagraphPart2",
                                    selectedlang,
                                  )}{" "}
                                  <b>{startDate}</b>.
                                </p>
                              </>
                            ) : (
                              <>
                                <p className="text-base text-gray-700 leading-relaxed mb-2">
                                  {localizationService.getLocalizationValue(
                                    "switchParagraphPart1",
                                    selectedlang,
                                  )}
                                  <b>{groupData?.[0]?.TreatmentName}</b>.{" "}
                                  {localizationService.getLocalizationValue(
                                    "switchParagraphPart2",
                                    selectedlang,
                                  )}
                                </p>
                              </>
                            )}
                            <p className="text-base text-gray-700 leading-relaxed">
                              {localizationService.getLocalizationValue(
                                "introParagraphPart3",
                                selectedlang,
                              )}
                            </p>
                            {submittedGroups.length > 1 ? (
                              <p className="text-base text-gray-700 leading-relaxed">
                                {localizationService.getLocalizationValue(
                                  "introParagraphPart4",
                                  selectedlang,
                                )}
                              </p>
                            ) : null}
                          </>
                        ) : step === groupData.length + 1 ? (
                          <>
                            <p className="text-base text-gray-700 leading-relaxed mb-4">
                              {localizationService.getLocalizationValue(
                                "introParagraphPart5",
                                selectedlang,
                              )}
                            </p>
                            <p className="text-base text-gray-700 leading-relaxed mb-4">
                              {localizationService.getLocalizationValue(
                                "introParagraphPart6",
                                selectedlang,
                              )}
                            </p>
                          </>
                        ) : (
                          <p className="text-base text-gray-700 leading-relaxed mb-4">
                            {localizationService.getLocalizationValue(
                              "introParagraphPart7",
                              selectedlang,
                            )}
                          </p>
                        )}
                      </div>
                      {step <= groupData.length ? (
                        <div className="bg-white rounded-2xl shadow-xl p-8 mb-6 flex justify-between">
                          {requestType === ClientRequestType.Switch ? (
                            <>
                              <div className="mb-6">
                                <h4 className="text-base font-semibold text-gray-700 mb-3">
                                  {localizationService.getLocalizationValue(
                                    "selectFirstAvailableWeek",
                                    selectedlang,
                                  )}
                                  :
                                </h4>
                                <div className="flex items-center justify-center gap-4">
                                  <button
                                    onClick={handlePrevious}
                                    disabled={isAtStart}
                                    className={`p-2 rounded-full focus:outline-none transition-colors ${
                                      isAtStart
                                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                        : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200 shadow-sm"
                                    }`}
                                  >
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M15 19l-7-7 7-7"
                                      />
                                    </svg>
                                  </button>

                                  <div className="text-sm font-medium text-gray-700 text-center">
                                    {availableWeeks[currentIndex].value}
                                  </div>

                                  <button
                                    onClick={handleNext}
                                    disabled={isAtEnd}
                                    className={`p-2 rounded-full focus:outline-none transition-colors ${
                                      isAtEnd
                                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                        : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200 shadow-sm"
                                    }`}
                                  >
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5l7 7-7 7"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          <div>
                            <h4 className="text-base font-semibold text-gray-700 mb-3">
                              {localizationService.getLocalizationValue(
                                "selectADay",
                                selectedlang,
                              )}
                            </h4>
                            <div className="hidden sm:flex gap-2 mb-4">
                              {daysForButtons.map((day) => (
                                <button
                                  key={day.value}
                                  onClick={() =>
                                    filterGroupsByDay(day.value, true)
                                  }
                                  className={`flex items-center justify-center px-4 py-2 rounded-lg font-medium focus:outline-none transition-colors ${
                                    selectedDay === day.value
                                      ? "bg-[#9aa82d] text-white ring-2 ring-[#7d8a1f]"
                                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                                  }`}
                                >
                                  {day.text}
                                </button>
                              ))}
                            </div>
                            <div className="grid grid-cols-6 gap-2 mb-4 sm:hidden">
                              {daysForButtons.map((day) => (
                                <button
                                  key={day.value}
                                  onClick={() =>
                                    filterGroupsByDay(day.value, true)
                                  }
                                  className={`flex items-center justify-center w-10 h-10 rounded-full font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#9aa82d] ${
                                    selectedDay === day.value
                                      ? "bg-[#9aa82d] text-white shadow-md transform scale-105"
                                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                                  }`}
                                >
                                  {day.text.substring(0, 1)}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {step <= groupData.length ? (
                        groupData[step - 1].SingleGroupResponse.filter(
                          (x) => x.StartDateDay == selectedDay,
                        ).length > 0 ? (
                          <Card className="mb-6">
                            <div className="space-y-4">
                              {/* Group by GroupName */}
                              {[
                                ...new Set(
                                  groupData[
                                    step - 1
                                  ].SingleGroupResponse.filter(
                                    (x) => x.StartDateDay == selectedDay,
                                  ).map((group) => group.GroupName),
                                ),
                              ].map((uniqueGroupName, groupIndex) => {
                                const groupsWithSameName = groupData[
                                  step - 1
                                ].SingleGroupResponse.filter(
                                  (x) =>
                                    x.StartDateDay == selectedDay &&
                                    x.GroupName === uniqueGroupName,
                                );

                                // Check if any group in this accordion is selected
                                const hasSelectedGroup =
                                  groupsWithSameName.some((g) => g.Selected);

                                const showGroupNameColumn =
                                  groupsWithSameName.some(
                                    (group) =>
                                      group.GroupName !== group.FullGroupName,
                                  );

                                return (
                                  <div
                                    key={groupIndex}
                                    className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200"
                                  >
                                    <div className="border-b border-gray-200">
                                      {/* Accordion Header */}
                                      <button
                                        onClick={() =>
                                          toggleAccordion(groupIndex)
                                        }
                                        className={`w-full px-3 sm:px-6 py-3 sm:py-4 flex items-center justify-between text-left focus:outline-none transition-colors duration-150 ${
                                          expandedAccordions.includes(
                                            groupIndex,
                                          )
                                            ? "bg-[#98a62d] text-white hover:bg-[#7d8a1f]"
                                            : "hover:bg-gray-50 text-gray-900"
                                        }`}
                                        aria-expanded={expandedAccordions.includes(
                                          groupIndex,
                                        )}
                                      >
                                        <div className="flex items-center space-x-4 flex-1">
                                          <h3
                                            className={`text-base sm:text-lg font-medium ${
                                              expandedAccordions.includes(
                                                groupIndex,
                                              )
                                                ? "text-white"
                                                : "text-gray-900"
                                            }`}
                                          >
                                            {groupsWithSameName[0].GroupName}
                                          </h3>
                                          {hasSelectedGroup && (
                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-white text-[#9aa82d]">
                                              <svg
                                                className="w-3 h-3 mr-1"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                              Selected
                                            </span>
                                          )}
                                        </div>
                                        <i
                                          className={`fas fa-chevron-down transform transition-transform duration-200 ${
                                            expandedAccordions.includes(
                                              groupIndex,
                                            )
                                              ? "rotate-180 text-white"
                                              : "text-gray-400"
                                          }`}
                                        ></i>
                                      </button>
                                    </div>

                                    {/* Accordion Body */}
                                    <div
                                      className={`transition-all duration-200 ease-in-out ${
                                        expandedAccordions.includes(groupIndex)
                                          ? "max-h-[2000px] opacity-100"
                                          : "max-h-0 opacity-0"
                                      } overflow-hidden`}
                                    >
                                      <div className="overflow-x-auto">
                                        <Table
                                          responsive="true"
                                          className="groupTable"
                                        >
                                          <TableHead>
                                            <TableRow>
                                              {showGroupNameColumn && (
                                                <TableHeaderCell>
                                                  {localizationService.getLocalizationValue(
                                                    "groupName",
                                                    selectedlang,
                                                  )}
                                                </TableHeaderCell>
                                              )}

                                              <TableHeaderCell>
                                                {requestType ===
                                                ClientRequestType.Switch
                                                  ? localizationService.getLocalizationValue(
                                                      "switchStartDateTime",
                                                      selectedlang,
                                                    )
                                                  : localizationService.getLocalizationValue(
                                                      "startDateTime",
                                                      selectedlang,
                                                    )}
                                              </TableHeaderCell>
                                              {requestType !==
                                                ClientRequestType.Switch && (
                                                <TableHeaderCell>
                                                  {localizationService.getLocalizationValue(
                                                    "endDateTime",
                                                    selectedlang,
                                                  )}
                                                </TableHeaderCell>
                                              )}
                                              <TableHeaderCell>
                                                {localizationService.getLocalizationValue(
                                                  "counsellor",
                                                  selectedlang,
                                                )}
                                              </TableHeaderCell>
                                              <TableHeaderCell className="text-center">
                                                {localizationService.getLocalizationValue(
                                                  "spaces",
                                                  selectedlang,
                                                )}
                                              </TableHeaderCell>
                                              {requestType !==
                                                ClientRequestType.Switch && (
                                                <TableHeaderCell className="text-center">
                                                  {localizationService.getLocalizationValue(
                                                    "sessionHeading",
                                                    selectedlang,
                                                  )}
                                                </TableHeaderCell>
                                              )}
                                              <TableHeaderCell className="text-center">
                                                {localizationService.getLocalizationValue(
                                                  "action",
                                                  selectedlang,
                                                )}
                                              </TableHeaderCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {groupsWithSameName.map(
                                              (group, index) => (
                                                <TableRow key={group.GroupId}>
                                                  {showGroupNameColumn && (
                                                    <TableCell>
                                                      {group.FullGroupName}
                                                    </TableCell>
                                                  )}

                                                  <TableCell>
                                                    {group.StartDate}
                                                  </TableCell>
                                                  {requestType !==
                                                    ClientRequestType.Switch && (
                                                    <TableCell>
                                                      {group.EndDate}
                                                    </TableCell>
                                                  )}
                                                  <TableCell>
                                                    {group.Counsellor}
                                                  </TableCell>
                                                  <TableCell className="text-center">
                                                    {group.Spaces}
                                                  </TableCell>
                                                  {requestType !==
                                                    ClientRequestType.Switch && (
                                                    <TableCell className="text-center">
                                                      {group.NumberOfSessions}
                                                    </TableCell>
                                                  )}
                                                  <TableCell className="text-center">
                                                    {group.Selected ? (
                                                      <Button
                                                        variant="danger"
                                                        onClick={() =>
                                                          deselectGroup(
                                                            group,
                                                            group.GroupId,
                                                          )
                                                        }
                                                        className="inline-flex items-center"
                                                      >
                                                        <svg
                                                          className="w-4 h-4 mr-1"
                                                          fill="none"
                                                          stroke="currentColor"
                                                          viewBox="0 0 24 24"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M6 18L18 6M6 6l12 12"
                                                          />
                                                        </svg>
                                                        {localizationService.getLocalizationValue(
                                                          "deselect",
                                                          selectedlang,
                                                        )}
                                                      </Button>
                                                    ) : (
                                                      <Button
                                                        variant="primary"
                                                        onClick={() =>
                                                          selectGroup(
                                                            group,
                                                            group.GroupId,
                                                          )
                                                        }
                                                      >
                                                        {localizationService.getLocalizationValue(
                                                          "select",
                                                          selectedlang,
                                                        )}
                                                      </Button>
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              ),
                                            )}
                                          </TableBody>
                                        </Table>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>

                            {/* Previous and Next buttons */}
                            <div className="flex justify-center items-center gap-3 mt-6">
                              <button
                                className={`px-4 py-2 rounded-md text-sm font-medium border border-gray-300 
                            ${
                              step === 1
                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                : "bg-white text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-[#9aa82d] focus:outline-none"
                            }`}
                                onClick={decrementStep}
                                disabled={step === 1}
                              >
                                <span className="flex items-center">
                                  <svg
                                    className="w-4 h-4 mr-1"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M15 19l-7-7 7-7"
                                    />
                                  </svg>
                                  {localizationService.getLocalizationValue(
                                    "previous",
                                    selectedlang,
                                  )}
                                </span>
                              </button>

                              {step > groupData.length ? (
                                <button
                                  className="px-4 py-2 rounded-md text-sm font-medium bg-[#9aa82d] hover:bg-[#7d8a1f] text-white focus:ring-2 focus:ring-[#9aa82d] focus:outline-none focus:ring-offset-2"
                                  onClick={Submit}
                                >
                                  <span className="flex items-center">
                                    {localizationService.getLocalizationValue(
                                      "submit",
                                      selectedlang,
                                    )}
                                    <svg
                                      className="w-4 h-4 ml-1"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5l7 7-7 7"
                                      />
                                    </svg>
                                  </span>
                                </button>
                              ) : (
                                <button
                                  className={`px-4 py-2 rounded-md text-sm font-medium 
                              ${
                                disableGoNext
                                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                  : "bg-[#9aa82d] hover:bg-[#7d8a1f] text-white focus:ring-2 focus:ring-[#9aa82d] focus:outline-none focus:ring-offset-2"
                              }`}
                                  onClick={incrementStep}
                                  disabled={disableGoNext}
                                >
                                  <span className="flex items-center">
                                    {localizationService.getLocalizationValue(
                                      "onboarding_next_btn",
                                      selectedlang,
                                    )}
                                    <svg
                                      className="w-4 h-4 ml-1"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5l7 7-7 7"
                                      />
                                    </svg>
                                  </span>
                                </button>
                              )}
                            </div>
                          </Card>
                        ) : (
                          <div className="rounded-lg border border-gray-200 p-6 mb-6 text-center bg-gray-50">
                            <p className="text-gray-600">
                              {localizationService.getLocalizationValue(
                                "noGroupsOnDate",
                                selectedlang,
                              )}
                            </p>
                          </div>
                        )
                      ) : (
                        <div className="bg-white rounded-2xl shadow-xl p-8">
                          <div>
                            <Table responsive="true" className="groupTable">
                              <thead>
                                <tr>
                                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    {localizationService.getLocalizationValue(
                                      "treatmentsTitle",
                                      selectedlang,
                                    )}
                                  </th>
                                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    {localizationService.getLocalizationValue(
                                      "group",
                                      selectedlang,
                                    )}
                                  </th>
                                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    {requestType ===
                                    ClientRequestType.Switch ? (
                                      <>
                                        {localizationService.getLocalizationValue(
                                          "switchStartDateTime",
                                          selectedlang,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {localizationService.getLocalizationValue(
                                          "startDateTime",
                                          selectedlang,
                                        )}
                                      </>
                                    )}
                                  </th>
                                  {requestType != ClientRequestType.Switch ? (
                                    <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                      {localizationService.getLocalizationValue(
                                        "endDateTime",
                                        selectedlang,
                                      )}
                                    </th>
                                  ) : null}
                                  <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    {localizationService.getLocalizationValue(
                                      "counsellor",
                                      selectedlang,
                                    )}
                                  </th>
                                  <th className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    {localizationService.getLocalizationValue(
                                      "spaces",
                                      selectedlang,
                                    )}
                                  </th>
                                  {requestType != ClientRequestType.Switch ? (
                                    <th className="px-6 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                      {localizationService.getLocalizationValue(
                                        "sessionHeading",
                                        selectedlang,
                                      )}
                                    </th>
                                  ) : null}
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-200">
                                {selectedGroups.map(
                                  (ProgramSelections, index) => (
                                    <tr
                                      key={index}
                                      className="hover:bg-gray-50 transition-colors"
                                    >
                                      <td className="px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700">
                                        {ProgramSelections[0].TreatmentName}
                                      </td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700">
                                        {ProgramSelections.map(
                                          (group, index2) => (
                                            <div
                                              key={index2}
                                              className="mb-1 last:mb-0"
                                            >
                                              {group.GroupName}
                                            </div>
                                          ),
                                        )}
                                      </td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700">
                                        {ProgramSelections.map(
                                          (group, index2) => (
                                            <div
                                              key={index2}
                                              className="mb-1 last:mb-0"
                                            >
                                              {group.StartDate}
                                            </div>
                                          ),
                                        )}
                                      </td>
                                      {requestType !=
                                      ClientRequestType.Switch ? (
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700">
                                          {ProgramSelections.map(
                                            (group, index2) => (
                                              <div
                                                key={index2}
                                                className="mb-1 last:mb-0"
                                              >
                                                {group.EndDate}
                                              </div>
                                            ),
                                          )}
                                        </td>
                                      ) : null}
                                      <td className="px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700">
                                        {ProgramSelections.map(
                                          (group, index2) => (
                                            <div
                                              key={index2}
                                              className="mb-1 last:mb-0"
                                            >
                                              {group.Counsellor}
                                            </div>
                                          ),
                                        )}
                                      </td>
                                      <td className="px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700 text-center">
                                        {ProgramSelections.map(
                                          (group, index2) => (
                                            <div
                                              key={index2}
                                              className="mb-1 last:mb-0 text-center"
                                            >
                                              {group.Spaces}
                                            </div>
                                          ),
                                        )}
                                      </td>
                                      {requestType !=
                                      ClientRequestType.Switch ? (
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-normal text-gray-700 text-center">
                                          {ProgramSelections.map(
                                            (group, index2) => (
                                              <div
                                                key={index2}
                                                className="mb-1 last:mb-0 text-center"
                                              >
                                                {group.NumberOfSessions}
                                              </div>
                                            ),
                                          )}
                                        </td>
                                      ) : null}
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </Table>

                            {/* Previous and Next buttons */}
                            <div
                              className="flex justify-center items-center gap-3 mt-4"
                              style={
                                requestType === ClientRequestType.Switch
                                  ? { marginBottom: "12px" }
                                  : {}
                              }
                            >
                              <button
                                className={`px-4 py-2 rounded-md text-sm font-medium border border-gray-300 
                            ${
                              step === 1
                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                : "bg-white text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-[#9aa82d] focus:outline-none"
                            }`}
                                onClick={decrementStep}
                                disabled={step === 1}
                              >
                                <span className="flex items-center">
                                  <svg
                                    className="w-4 h-4 mr-1"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M15 19l-7-7 7-7"
                                    />
                                  </svg>
                                  {localizationService.getLocalizationValue(
                                    "previous",
                                    selectedlang,
                                  )}
                                </span>
                              </button>

                              {step > groupData.length ? (
                                <button
                                  className="px-4 py-2 rounded-md text-sm font-medium bg-[#9aa82d] hover:bg-[#7d8a1f] text-white focus:ring-2 focus:ring-[#9aa82d] focus:outline-none focus:ring-offset-2"
                                  onClick={Submit}
                                >
                                  <span className="flex items-center">
                                    {localizationService.getLocalizationValue(
                                      "submit",
                                      selectedlang,
                                    )}
                                    <svg
                                      className="w-4 h-4 ml-1"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5l7 7-7 7"
                                      />
                                    </svg>
                                  </span>
                                </button>
                              ) : (
                                <button
                                  className={`px-4 py-2 rounded-md text-sm font-medium 
                              ${
                                disableGoNext
                                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                  : "bg-[#9aa82d] hover:bg-[#7d8a1f] text-white focus:ring-2 focus:ring-[#9aa82d] focus:outline-none focus:ring-offset-2"
                              }`}
                                  onClick={incrementStep}
                                  disabled={disableGoNext}
                                >
                                  <span className="flex items-center">
                                    {localizationService.getLocalizationValue(
                                      "next",
                                      selectedlang,
                                    )}
                                    <svg
                                      className="w-4 h-4 ml-1"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5l7 7-7 7"
                                      />
                                    </svg>
                                  </span>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : submitted ? (
                <div className="main-container-mobile">
                  <div className="content-container-mobile submitted-request">
                    <h4 className="intro-title-mobile submitted-request">
                      {localizationService.getLocalizationValue(
                        "submittedRequest",
                        selectedlang,
                      )}
                    </h4>
                    <div className="group-name-container-mobile submitted-request">
                      {submittedGroups.map((treatment, tretIndex) => (
                        <button
                          className={
                            "group-name-mobile" +
                            (treatmentToShow &&
                            treatment.TreatmentId ===
                              treatmentToShow.TreatmentId
                              ? " active"
                              : "")
                          }
                          key={tretIndex}
                          onClick={() => showSelectedTreatment(tretIndex)}
                        >
                          {treatment.TreatmentName}
                        </button>
                      ))}
                    </div>
                    <div className="table-box mobile w-full">
                      {treatmentToShow &&
                        treatmentToShow.SingleGroupResponse &&
                        treatmentToShow.SingleGroupResponse.map(
                          (treatment, tretIndex) => (
                            <Table
                              responsive="true"
                              key={tretIndex}
                              className="group-table mobile w-100"
                              style={{ fontSize: "1.1rem" }}
                            >
                              <thead>
                                <tr>
                                  <th
                                    className="full-group-name"
                                    colSpan="2"
                                    style={{ padding: "12px 8px" }}
                                  >
                                    {treatment.FullGroupName}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th style={{ padding: "12px 8px" }}>
                                    {localizationService.getLocalizationValue(
                                      "group",
                                      selectedlang,
                                    )}
                                  </th>

                                  <td style={{ padding: "12px 8px" }}>
                                    {treatment ? treatment.GroupName : ""}
                                  </td>
                                </tr>
                                <tr>
                                  {requestType === ClientRequestType.Switch ? (
                                    <>
                                      <th style={{ padding: "12px 8px" }}>
                                        {localizationService.getLocalizationValue(
                                          "switchStartDateTime",
                                          selectedlang,
                                        )}
                                      </th>
                                    </>
                                  ) : (
                                    <>
                                      <th style={{ padding: "12px 8px" }}>
                                        {localizationService.getLocalizationValue(
                                          "startDateTime",
                                          selectedlang,
                                        )}
                                      </th>
                                    </>
                                  )}
                                  <td style={{ padding: "12px 8px" }}>
                                    {treatment ? treatment.StartDate : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <th style={{ padding: "12px 8px" }}>
                                    {localizationService.getLocalizationValue(
                                      "counsellor",
                                      selectedlang,
                                    )}
                                  </th>
                                  <td style={{ padding: "12px 8px" }}>
                                    {treatment ? treatment.Counsellor : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <th style={{ padding: "12px 8px" }}>
                                    {localizationService.getLocalizationValue(
                                      "spaces",
                                      selectedlang,
                                    )}
                                  </th>
                                  <td style={{ padding: "12px 8px" }}>
                                    {treatment ? treatment.Spaces : ""}
                                  </td>
                                </tr>
                                {requestType === ClientRequestType.Switch ? (
                                  <></>
                                ) : (
                                  <>
                                    <tr>
                                      <th style={{ padding: "12px 8px" }}>
                                        {localizationService.getLocalizationValue(
                                          "sessionHeading",
                                          selectedlang,
                                        )}
                                      </th>
                                      <td style={{ padding: "12px 8px" }}>
                                        {treatment
                                          ? treatment.NumberOfSessions
                                          : ""}
                                      </td>
                                    </tr>
                                  </>
                                )}
                                <tr>
                                  <th style={{ padding: "12px 8px" }}>
                                    Status
                                  </th>
                                  <td
                                    className="status-td"
                                    style={{ padding: "12px 8px" }}
                                  >
                                    {treatment.Status === 2 ? (
                                      <Badge variant="warning">
                                        {localizationService.getLocalizationValue(
                                          "pending",
                                          selectedlang,
                                        )}
                                      </Badge>
                                    ) : treatment.Status === 3 ? (
                                      <Badge variant="success">
                                        {localizationService.getLocalizationValue(
                                          "approved",
                                          selectedlang,
                                        )}
                                      </Badge>
                                    ) : (
                                      <Badge variant="danger">
                                        {localizationService.getLocalizationValue(
                                          "rejected",
                                          selectedlang,
                                        )}
                                      </Badge>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          ),
                        )}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="main-container-mobile"
                  style={{ width: "100%", maxWidth: "100%" }}
                >
                  <div
                    className="stepper-container-mobile"
                    style={{ width: "100%", maxWidth: "100%" }}
                  >
                    <div style={{ width: "100%", maxWidth: "100%" }}>
                      <Stepper
                        steps={[
                          ...groupData.map((data) => ({
                            name: data.TreatmentName,
                          })),
                          {
                            name: localizationService.getLocalizationValue(
                              "reviewAndSubmit",
                              selectedlang,
                            ),
                          },
                        ]}
                        currentStep={step}
                        complete={step > groupData.length + 1}
                      />
                    </div>
                  </div>

                  <div className="content-container-mobile">
                    {requestType === ClientRequestType.Switch ? (
                      <>
                        <h4 className="intro-title-mobile mb-3 uppercase text-xl">
                          {step === 1
                            ? localizationService.getLocalizationValue(
                                "programsTitleSwitch",
                                selectedlang,
                              )
                            : step === groupData.length + 1
                              ? localizationService.getLocalizationValue(
                                  "reviewAndSubmit",
                                  selectedlang,
                                )
                              : localizationService.getLocalizationValue(
                                  "programsTitleSwitch",
                                  selectedlang,
                                )}
                        </h4>
                      </>
                    ) : (
                      <>
                        <h4 className="intro-title-mobile mb-3 uppercase">
                          {step === 1
                            ? localizationService.getLocalizationValue(
                                "programsTitle",
                                selectedlang,
                              )
                            : step === groupData.length + 1
                              ? localizationService.getLocalizationValue(
                                  "reviewAndSubmit",
                                  selectedlang,
                                )
                              : localizationService.getLocalizationValue(
                                  "programsTitle",
                                  selectedlang,
                                )}
                        </h4>
                      </>
                    )}
                    <div className="step-one-intro-box mobile">
                      {step === 1 ? (
                        <>
                          {requestType === ClientRequestType.Switch ? (
                            <>
                              <p className="step-one-intro mb-1">
                                {localizationService.getLocalizationValue(
                                  "switchParagraphPart1",
                                  selectedlang,
                                )}{" "}
                                <b>{groupData?.[0]?.TreatmentName}</b>.{" "}
                                {localizationService.getLocalizationValue(
                                  "switchParagraphPart2",
                                  selectedlang,
                                )}{" "}
                              </p>
                            </>
                          ) : (
                            <>
                              <p className="step-one-intro mb-2">
                                {localizationService.getLocalizationValue(
                                  "introParagraphPart1",
                                  selectedlang,
                                )}{" "}
                                <b>{endDate}</b>.{" "}
                                {localizationService.getLocalizationValue(
                                  "introParagraphPart2",
                                  selectedlang,
                                )}{" "}
                                <b>{startDate}</b>.
                              </p>
                            </>
                          )}
                          <p className="step-one-intro">
                            {localizationService.getLocalizationValue(
                              "introParagraphPart3",
                              selectedlang,
                            )}
                          </p>
                          {submittedGroups.length > 1 ? (
                            <p className="step-one-intro">
                              {localizationService.getLocalizationValue(
                                "introParagraphPart4",
                                selectedlang,
                              )}
                            </p>
                          ) : null}
                          {requestType === ClientRequestType.Switch ? (
                            <>
                              <br></br>
                              <div className="mb-6">
                                <h4 className="text-base font-semibold text-gray-700">
                                  {localizationService.getLocalizationValue(
                                    "selectFirstAvailableWeek",
                                    selectedlang,
                                  )}
                                  :
                                </h4>
                                <div className="flex items-center justify-center gap-4 pt-3 pb-4 bg-gray-50 rounded-lg justify-between">
                                  <button
                                    onClick={handlePrevious}
                                    disabled={isAtStart}
                                    className={`p-2 rounded-full focus:outline-none transition-colors ${
                                      isAtStart
                                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                        : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200 shadow-sm"
                                    }`}
                                  >
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M15 19l-7-7 7-7"
                                      />
                                    </svg>
                                  </button>

                                  <div className="text-sm font-medium text-gray-700 text-center">
                                    {availableWeeks[currentIndex].value}
                                  </div>

                                  <button
                                    onClick={handleNext}
                                    disabled={isAtEnd}
                                    className={`p-2 rounded-full focus:outline-none transition-colors ${
                                      isAtEnd
                                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                        : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-200 shadow-sm"
                                    }`}
                                  >
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5l7 7-7 7"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : step === groupData.length + 1 ? (
                        <>
                          <p className="step-one-intro">
                            {localizationService.getLocalizationValue(
                              "introParagraphPart5",
                              selectedlang,
                            )}
                          </p>
                          <p className="step-one-intro">
                            {localizationService.getLocalizationValue(
                              "introParagraphPart6",
                              selectedlang,
                            )}
                          </p>
                        </>
                      ) : (
                        <p className="step-one-intro">
                          {localizationService.getLocalizationValue(
                            "introParagraphPart7",
                            selectedlang,
                          )}
                        </p>
                      )}
                    </div>
                    {step <= groupData.length ? (
                      <div className="mb-6">
                        <h4 className="text-base font-semibold text-gray-700 mb-3">
                          {localizationService.getLocalizationValue(
                            "selectADay",
                            selectedlang,
                          )}
                        </h4>
                        <div className="hidden sm:flex gap-2 mb-4">
                          {daysForButtons.map((day) => (
                            <button
                              key={day.value}
                              onClick={() => filterGroupsByDay(day.value, true)}
                              className={`flex items-center justify-center px-4 py-2 rounded-lg font-medium focus:outline-none transition-colors ${
                                selectedDay === day.value
                                  ? "bg-[#9aa82d] text-white ring-2 ring-[#7d8a1f]"
                                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                              }`}
                            >
                              {day.text}
                            </button>
                          ))}
                        </div>
                        <div className="grid grid-cols-6 gap-2 mb-4 sm:hidden">
                          {daysForButtons.map((day) => (
                            <button
                              key={day.value}
                              onClick={() => filterGroupsByDay(day.value, true)}
                              className={`flex items-center justify-center w-10 h-10 rounded-full font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#9aa82d] ${
                                selectedDay === day.value
                                  ? "bg-[#9aa82d] text-white shadow-md transform scale-105"
                                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                              }`}
                            >
                              {day.text.substring(0, 1)}
                            </button>
                          ))}
                        </div>
                      </div>
                    ) : null}
                    <div className="flex flex-wrap gap-2 mb-6">
                      {groupData.length > 0
                        ? step <= groupData.length
                          ? [
                              ...new Set(
                                groupData[step - 1].SingleGroupResponse.filter(
                                  (x) => x.StartDateDay === selectedDay,
                                ).map((group) => group.GroupName),
                              ),
                            ].map((uniqueGroupName, index) => (
                              <button
                                key={index}
                                onClick={() =>
                                  showGroupInfoByGroupName(uniqueGroupName)
                                }
                                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                                  uniqueGroupName === groupToShow.GroupName
                                    ? "bg-[#9aa82d] text-white"
                                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                                }`}
                              >
                                {uniqueGroupName}
                              </button>
                            ))
                          : groupData.map((treatment, tretIndex) => (
                              <button
                                key={tretIndex}
                                onClick={() => showSelectedTreatment(tretIndex)}
                                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                                  treatmentToShow.length > 0 &&
                                  treatment.TreatmentId ===
                                    treatmentToShow[0].TreatmentId
                                    ? "bg-[#9aa82d] text-white"
                                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                                }`}
                              >
                                {treatment.TreatmentName}
                              </button>
                            ))
                        : null}
                    </div>
                    <div className="table-box mobile">
                      {step <= groupData.length ? (
                        groupData[step - 1].SingleGroupResponse.filter(
                          (x) => x.StartDateDay === selectedDay,
                        ).length > 0 ? (
                          groupData[step - 1].SingleGroupResponse.filter(
                            (x) =>
                              x.StartDateDay === selectedDay &&
                              x.GroupName === groupToShow.GroupName,
                          ).length > 1 ? (
                            <Swiper
                              navigation={true}
                              modules={[Navigation]}
                              className="mySwiper"
                              onSlideChange={handleSlideChange}
                            >
                              {groupData[step - 1].SingleGroupResponse.filter(
                                (x) =>
                                  x.StartDateDay === selectedDay &&
                                  x.GroupName === groupToShow.GroupName,
                              ).map((group, index) => (
                                <SwiperSlide key={index}>
                                  <div className="mb-4">
                                    <div className="px-4 py-3 bg-[#f5f7eb]">
                                      <h3 className="text-base font-semibold text-[#7d8a1f]">
                                        {group.FullGroupName}
                                      </h3>
                                    </div>
                                    <div className="p-4 bg-white text-sm">
                                      <div className="space-y-3">
                                        <div className="flex justify-between py-2 border-b border-gray-100">
                                          <span className="font-bold text-gray-700">
                                            {requestType ===
                                            ClientRequestType.Switch ? (
                                              <>
                                                {localizationService.getLocalizationValue(
                                                  "switchStartDateTimeMobFirstPart",
                                                  selectedlang,
                                                )}
                                                <br />
                                                {localizationService.getLocalizationValue(
                                                  "switchStartDateTimeMobSecondPart",
                                                  selectedlang,
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {localizationService.getLocalizationValue(
                                                  "startDateTimeMobFirtsPart",
                                                  selectedlang,
                                                )}
                                                <br />
                                                {localizationService.getLocalizationValue(
                                                  "startDateTimeMobSecondPart",
                                                  selectedlang,
                                                )}
                                              </>
                                            )}
                                          </span>
                                          <span
                                            className="text-gray-900"
                                            style={{
                                              width: "119px",
                                              paddingLeft: "11px",
                                            }}
                                          >
                                            {group.StartDate}
                                          </span>
                                        </div>

                                        {requestType !==
                                          ClientRequestType.Switch && (
                                          <div className="flex justify-between py-2 border-b border-gray-100">
                                            <span className="font-bold text-gray-700">
                                              {localizationService.getLocalizationValue(
                                                "endDateTime",
                                                selectedlang,
                                              )}
                                            </span>
                                            <span className="text-gray-900">
                                              {group.EndDate}
                                            </span>
                                          </div>
                                        )}

                                        <div className="flex justify-between py-2 border-b border-gray-100">
                                          <span className="font-bold text-gray-700">
                                            {localizationService.getLocalizationValue(
                                              "counsellorMobileView",
                                              selectedlang,
                                            )}
                                            <br />
                                            {localizationService.getLocalizationValue(
                                              "therapistMobileView",
                                              selectedlang,
                                            )}
                                          </span>
                                          <span
                                            className="text-gray-900"
                                            style={{ paddingLeft: "32px" }}
                                          >
                                            {group.Counsellor}
                                          </span>
                                        </div>

                                        <div className="flex justify-between py-2 border-b border-gray-100">
                                          <span className="font-bold text-gray-700">
                                            {localizationService.getLocalizationValue(
                                              "spaces",
                                              selectedlang,
                                            )}
                                          </span>
                                          <span className="text-gray-900">
                                            {group.Spaces}
                                          </span>
                                        </div>

                                        {requestType !==
                                          ClientRequestType.Switch && (
                                          <div className="flex justify-between py-2 border-b border-gray-100">
                                            <span className="font-bold text-gray-700">
                                              {localizationService.getLocalizationValue(
                                                "sessionHeading",
                                                selectedlang,
                                              )}
                                            </span>
                                            <span className="text-gray-900">
                                              {group.NumberOfSessions}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </SwiperSlide>
                              ))}
                            </Swiper>
                          ) : (
                            groupData[step - 1].SingleGroupResponse.filter(
                              (x) =>
                                x.StartDateDay === selectedDay &&
                                x.GroupName === groupToShow.GroupName,
                            ).map((group, index) => (
                              <div key={index} className="mb-4">
                                <div className="px-4 py-3 bg-[#f5f7eb]">
                                  <h3 className="text-base font-semibold text-[#7d8a1f]">
                                    {group.FullGroupName}
                                  </h3>
                                </div>
                                <div className="p-4 bg-white text-sm">
                                  <div className="space-y-3">
                                    <div className="flex justify-between py-2 border-b border-gray-100">
                                      <span className="font-bold text-gray-700">
                                        {requestType ===
                                        ClientRequestType.Switch ? (
                                          <>
                                            {localizationService.getLocalizationValue(
                                              "switchStartDateTimeMobFirstPart",
                                              selectedlang,
                                            )}
                                            <br />
                                            {localizationService.getLocalizationValue(
                                              "switchStartDateTimeMobSecondPart",
                                              selectedlang,
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {localizationService.getLocalizationValue(
                                              "startDateTimeMobFirtsPart",
                                              selectedlang,
                                            )}
                                            <br />
                                            {localizationService.getLocalizationValue(
                                              "startDateTimeMobSecondPart",
                                              selectedlang,
                                            )}
                                          </>
                                        )}
                                      </span>
                                      <span
                                        className="text-gray-900"
                                        style={{
                                          width: "119px",
                                          paddingLeft: "29px",
                                        }}
                                      >
                                        {group.StartDate}
                                      </span>
                                    </div>

                                    {requestType ===
                                    ClientRequestType.Switch ? null : (
                                      <div className="flex justify-between py-2 border-b border-gray-100">
                                        <span className="font-bold text-gray-700">
                                          {localizationService.getLocalizationValue(
                                            "endDateTime",
                                            selectedlang,
                                          )}
                                        </span>
                                        <span className="text-gray-900">
                                          {group.EndDate}
                                        </span>
                                      </div>
                                    )}

                                    <div className="flex justify-between py-2 border-b border-gray-100">
                                      <span className="font-bold text-gray-700">
                                        {localizationService.getLocalizationValue(
                                          "counsellorMobileView",
                                          selectedlang,
                                        )}
                                        <br />
                                        {localizationService.getLocalizationValue(
                                          "therapistMobileView",
                                          selectedlang,
                                        )}
                                      </span>
                                      <span
                                        className="text-gray-900"
                                        style={{ paddingLeft: "32px" }}
                                      >
                                        {group.Counsellor}
                                      </span>
                                    </div>

                                    <div className="flex justify-between py-2 border-b border-gray-100">
                                      <span className="font-bold text-gray-700">
                                        {localizationService.getLocalizationValue(
                                          "spaces",
                                          selectedlang,
                                        )}
                                      </span>
                                      <span className="text-gray-900">
                                        {group.Spaces}
                                      </span>
                                    </div>

                                    {requestType ===
                                    ClientRequestType.Switch ? null : (
                                      <div className="flex justify-between py-2 border-b border-gray-100">
                                        <span className="font-bold text-gray-700">
                                          {localizationService.getLocalizationValue(
                                            "sessionHeading",
                                            selectedlang,
                                          )}
                                        </span>
                                        <span className="text-gray-900">
                                          {group.NumberOfSessions}
                                        </span>
                                      </div>
                                    )}
                                  </div>

                                  {/* Select Group button removed to avoid duplication */}
                                </div>
                              </div>
                            ))
                          )
                        ) : (
                          <div className="no-groups-on-day-box mobile">
                            <p className="no-groups-on-day mobile">
                              {localizationService.getLocalizationValue(
                                "noGroupsOnDate",
                                selectedlang,
                              )}{" "}
                            </p>
                          </div>
                        )
                      ) : treatmentToShow.length > 0 ? (
                        treatmentToShow.map((treatment, tretIndex) => (
                          <div key={tretIndex} className="mb-4">
                            <div className="px-4 py-3 bg-[#f5f7eb]">
                              <h3 className="text-base font-semibold text-[#7d8a1f]">
                                {treatment.FullGroupName}
                              </h3>
                            </div>
                            <div className="p-4 bg-white text-sm">
                              <div className="space-y-3">
                                <div className="flex justify-between py-2 border-b border-gray-100">
                                  <span className="font-bold text-gray-700">
                                    {localizationService.getLocalizationValue(
                                      "group",
                                      selectedlang,
                                    )}
                                  </span>
                                  <span className="text-gray-900">
                                    {treatment ? treatment.GroupName : ""}
                                  </span>
                                </div>

                                <div className="flex justify-between py-2 border-b border-gray-100">
                                  <span className="font-bold text-gray-700">
                                    {requestType ===
                                    ClientRequestType.Switch ? (
                                      <>
                                        {localizationService.getLocalizationValue(
                                          "switchStartDateTimeMobFirstPart",
                                          selectedlang,
                                        )}
                                        <br />
                                        {localizationService.getLocalizationValue(
                                          "switchStartDateTimeMobSecondPart",
                                          selectedlang,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {localizationService.getLocalizationValue(
                                          "startDateTimeMobFirtsPart",
                                          selectedlang,
                                        )}
                                        <br />
                                        {localizationService.getLocalizationValue(
                                          "startDateTimeMobSecondPart",
                                          selectedlang,
                                        )}
                                      </>
                                    )}
                                  </span>
                                  <span
                                    className="text-gray-900"
                                    style={{
                                      paddingLeft: "38px",
                                    }}
                                  >
                                    {treatment ? treatment.StartDate : ""}
                                  </span>
                                </div>

                                {requestType ===
                                ClientRequestType.Switch ? null : (
                                  <div className="flex justify-between py-2 border-b border-gray-100">
                                    <span className="font-bold text-gray-700">
                                      {localizationService.getLocalizationValue(
                                        "endDateTime",
                                        selectedlang,
                                      )}
                                    </span>
                                    <span className="text-gray-900">
                                      {treatment ? treatment.EndDate : ""}
                                    </span>
                                  </div>
                                )}

                                <div className="flex justify-between py-2 border-b border-gray-100">
                                  <span className="font-bold text-gray-700">
                                    {localizationService.getLocalizationValue(
                                      "counsellorMobileView",
                                      selectedlang,
                                    )}
                                    <br />
                                    {localizationService.getLocalizationValue(
                                      "therapistMobileView",
                                      selectedlang,
                                    )}
                                  </span>
                                  <span
                                    className="text-gray-900"
                                    style={{ paddingLeft: "28px" }}
                                  >
                                    {treatment ? treatment.Counsellor : ""}
                                  </span>
                                </div>

                                <div className="flex justify-between py-2 border-b border-gray-100">
                                  <span className="font-bold text-gray-700">
                                    {localizationService.getLocalizationValue(
                                      "spaces",
                                      selectedlang,
                                    )}
                                  </span>
                                  <span className="text-gray-900">
                                    {treatment ? treatment.Spaces : ""}
                                  </span>
                                </div>

                                {requestType ===
                                ClientRequestType.Switch ? null : (
                                  <div className="flex justify-between py-2 border-b border-gray-100">
                                    <span className="font-bold text-gray-700">
                                      {localizationService.getLocalizationValue(
                                        "sessionHeading",
                                        selectedlang,
                                      )}
                                    </span>
                                    <span className="text-gray-900">
                                      {treatment
                                        ? treatment.NumberOfSessions
                                        : ""}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : null}
                    </div>

                    {step <= groupData.length ? (
                      <>
                        {groupData[step - 1].SingleGroupResponse.filter(
                          (x) => x.StartDateDay == selectedDay,
                        ).length > 0 ? (
                          <>
                            {groupData[step - 1].SingleGroupResponse.filter(
                              (x) =>
                                x.StartDateDay === selectedDay &&
                                x.GroupName === groupToShow.GroupName,
                            ).length > 1 ? (
                              <div className="mt-4">
                                {(() => {
                                  // Get current slide from the swiper
                                  const filteredGroups = groupData[
                                    step - 1
                                  ].SingleGroupResponse.filter(
                                    (x) =>
                                      x.StartDateDay === selectedDay &&
                                      x.GroupName === groupToShow.GroupName,
                                  );

                                  const currentGroup =
                                    filteredGroups[
                                      Math.min(
                                        activeSlideIndex,
                                        filteredGroups.length - 1,
                                      )
                                    ];

                                  return currentGroup &&
                                    currentGroup.Selected ? (
                                    <button
                                      className="w-full flex items-center justify-center py-2 px-4 bg-red-600 rounded-md text-white font-medium shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1 transition-colors"
                                      onClick={() =>
                                        deSelectGroupMobile(
                                          currentGroup.GroupId,
                                        )
                                      }
                                    >
                                      <svg
                                        className="w-5 h-5 mr-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M6 18L18 6M6 6l12 12"
                                        />
                                      </svg>
                                      {localizationService.getLocalizationValue(
                                        "modalDeselectGroupTitle",
                                        selectedlang,
                                      )}
                                    </button>
                                  ) : (
                                    <button
                                      className="w-full flex items-center justify-center py-2 px-4 bg-[#9aa82d] rounded-md text-white font-medium shadow-sm hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-[#9aa82d] focus:ring-offset-1 transition-colors"
                                      onClick={() =>
                                        selectGroupMobile(currentGroup.GroupId)
                                      }
                                    >
                                      <svg
                                        className="w-5 h-5 mr-2"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M5 13l4 4L19 7"
                                        />
                                      </svg>
                                      {localizationService.getLocalizationValue(
                                        "selectGroup",
                                        selectedlang,
                                      )}
                                    </button>
                                  );
                                })()}
                              </div>
                            ) : (
                              <div className="mt-4">
                                {groupToShow && groupToShow.Selected ? (
                                  <button
                                    className="w-full flex items-center justify-center py-2 px-4 bg-red-600 rounded-md text-white font-medium shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1 transition-colors"
                                    onClick={() =>
                                      deSelectGroupMobile(groupToShow.GroupId)
                                    }
                                  >
                                    <svg
                                      className="w-5 h-5 mr-2"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12"
                                      />
                                    </svg>
                                    {localizationService.getLocalizationValue(
                                      "modalDeselectGroupTitle",
                                      selectedlang,
                                    )}
                                  </button>
                                ) : (
                                  <button
                                    className="w-full flex items-center justify-center py-2 px-4 bg-[#9aa82d] rounded-md text-white font-medium shadow-sm hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-[#9aa82d] focus:ring-offset-1 transition-colors"
                                    onClick={() =>
                                      selectGroupMobile(groupToShow.GroupId)
                                    }
                                  >
                                    <svg
                                      className="w-5 h-5 mr-2"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                      />
                                    </svg>
                                    {localizationService.getLocalizationValue(
                                      "selectGroup",
                                      selectedlang,
                                    )}
                                  </button>
                                )}
                              </div>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                        <div className="mt-[16px] mb-[16px]">
                          <div
                            className="flex justify-between items-center"
                            style={{ width: "100%" }}
                          >
                            <button
                              onClick={decrementStep}
                              disabled={step === 1}
                              className={`flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium transition-colors w-1/2 mr-1 ${
                                step === 1
                                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                                  : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 shadow-sm"
                              }`}
                            >
                              <svg
                                className="w-4 h-4 mr-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M15 19l-7-7 7-7"
                                />
                              </svg>
                              {localizationService.getLocalizationValue(
                                "backBtn",
                                selectedlang,
                              )}
                            </button>
                            <button
                              className={`flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium w-1/2 ml-1 ${
                                disableGoNext
                                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                  : "bg-[#9aa82d] hover:bg-[#7d8a1f] text-white shadow-sm"
                              }`}
                              onClick={incrementStep}
                              disabled={disableGoNext}
                            >
                              {localizationService.getLocalizationValue(
                                "next",
                                selectedlang,
                              )}
                              <svg
                                className="w-4 h-4 ml-1"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M9 5l7 7-7 7"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="mt-8 mb-4">
                        <div
                          className="flex justify-between items-center"
                          style={{ width: "100%" }}
                        >
                          <button
                            onClick={decrementStep}
                            className="flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 shadow-sm w-1/2 mr-1"
                          >
                            <svg
                              className="w-4 h-4 mr-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 19l-7-7 7-7"
                              />
                            </svg>
                            {localizationService.getLocalizationValue(
                              "backBtn",
                              selectedlang,
                            )}
                          </button>
                          <button
                            className="flex items-center justify-center px-4 py-2 rounded-md text-sm font-medium bg-[#9aa82d] hover:bg-[#7d8a1f] text-white shadow-sm w-1/2 ml-1"
                            onClick={() => Submit()}
                          >
                            {localizationService.getLocalizationValue(
                              "submit",
                              selectedlang,
                            )}
                            <svg
                              className="w-4 h-4 ml-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : null
        ) : null}
      </React.Fragment>
    </MasterPage>
  );
};
